import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=f17ee1b0&scoped=true&"
import script from "./ChatPopup.vue?vue&type=script&lang=js&"
export * from "./ChatPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=f17ee1b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17ee1b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
